// src/api.js
const LOCAL_API = "http://localhost:4001";
const CONFIGURED_API = (process.env.REACT_APP_API_BASE_URL || "").trim();

const isLocalApi = (value) => /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(value);

const isLocalDev = () => {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

const isCapacitorRuntime = () => {
  const protocol = window.location.protocol;
  return protocol === "capacitor:" || Boolean(window.Capacitor);
};

const getConfiguredHostedApiBase = () => (
  CONFIGURED_API && !isLocalApi(CONFIGURED_API) ? CONFIGURED_API.replace(/\/$/, "") : ""
);

const getCapacitorApiBase = () => {
  const configuredHostedApi = getConfiguredHostedApiBase();
  if (configuredHostedApi) {
    return configuredHostedApi;
  }

  console.warn("REACT_APP_API_BASE_URL is not set for Capacitor runtime; API requests will use same-origin and may fail outside hosted web.");
  return "";
};

export const API_BASE_URL = (
  isLocalDev()
    ? (CONFIGURED_API || LOCAL_API)
    : isCapacitorRuntime()
      ? getCapacitorApiBase()
      : ""
).replace(/\/$/, "");

console.log("🔗 Using API base:", API_BASE_URL || "(same-origin)");
